import { Col, Row } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import CalenderCom from "../Components/CalenderCom";
import FullCalendarCom from "../Components/FullCalendar";

const filter = [
  {
    title: "View All",
    color: "#8F8F8F",
  },
  {
    title: "Meetings",
    color: "#FF6B38",
  },
  {
    title: "Challenges",
    color: "#9945C2",
  },
  {
    title: "Courses",
    color: "#FF3D4A",
  },
  {
    title: "Tasks",
    color: "#52B070",
  },
];

function Calender() {
  const CalenderDetails = useSelector((state) => state.user.calenderDetails);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isFromSideCalender, setIsFromSideCalender] = useState(false);
  const [currentSelect, setCurrentSelect] = useState([filter[0].title]);

  const handleCheckboxChange = (title, isChecked) => {
    console.log(title, isChecked, "title, isChecked");
    if (title === "View All" && isChecked) {
      setCurrentSelect(["View All"]);
    } else if (title === "View All" && !isChecked) {
      setCurrentSelect((prev) => prev.filter((item) => item !== "View All"));
    } else if (isChecked) {
      setCurrentSelect((prev) => [
        ...prev.filter((item) => item !== "View All"),
        title,
      ]);
    } else {
      setCurrentSelect((prev) => [
        ...prev.filter((item) => item !== "View All" && item !== title),
      ]);
    }
  };

  const filteredEvents = CalenderDetails.filter((detail) => {
    if (currentSelect.length === 0 || currentSelect[0] === "View All")
      return true;
    // Filter based on selected categories
    return currentSelect.includes(detail.EventType);
  });
  return (
    <Row
      gutter={15}
      className="bg-pureWhite rounded-3xl shadow-chatBoxShadow p-5"
    >
      <Col span={8}>
        <CalenderCom
          checkboxStates={currentSelect}
          filter={filter}
          handleCheckboxChange={handleCheckboxChange}
          isModalVisible={isModalVisible}
          toggleModal={(value) => {
            setIsModalVisible(value);
            setIsFromSideCalender(true);
          }}
        />
      </Col>
      <Col span={16}>
        <FullCalendarCom
          filteredEvents={filteredEvents}
          isModalVisible={isModalVisible}
          toggleModal={(value) => setIsModalVisible(value)}
          editModal={(value) => setIsModalVisible(value)}
          isFromSideCalender={isFromSideCalender}
        />
      </Col>
    </Row>
  );
}

export default Calender;
